// extracted by mini-css-extract-plugin
module.exports = {"statusIcon":"styles_statusIcon__3wyV2"};